import { initializeApp } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'
import { getMessaging, getToken, onMessage } from 'firebase/messaging'
import { showToast } from 'utils/toast'

const firebaseConfig = {
    apiKey: 'AIzaSyDXNPVC4tHOpaAZJAdhvESLpgGvRlrQdCM',
    authDomain: 'gt-holidays.firebaseapp.com',
    projectId: 'gt-holidays',
    storageBucket: 'gt-holidays.appspot.com',
    messagingSenderId: '887786282132',
    appId: '1:887786282132:web:a7c9c97f2409e5dcfd6881',
    measurementId: 'G-YX26E9VG1S',
}

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig)
const analytics = getAnalytics(firebaseApp)

const messaging = getMessaging(firebaseApp)

export const getFirebaseToken = async () => {
    return await getToken(messaging, {
        vapidKey:
            'BNi3y1uBfS377HQbHyatrB2EnHlfCFe6fozFKgoVKT_BadGOm2v0cWGbqpWnFUemqOu0CqktKdJTByHK8FLtoD8',
    })
}

onMessage(messaging, (payload) => {
    console.log('Message received. ', payload)
    // showToast({
    //     type: 'success',
    //     title: payload.notification.title,
    //     message: payload.notification.body,
    // })
    // new Notification()
    // ...
    const notificationTitle = payload.notification.title
    const notificationOptions = {
        body: payload.notification.body,
        icon: './img/logo/logo-light-streamline.png',
    }

    new Notification(notificationTitle, notificationOptions)
})
